import { AlbumContentSerialized } from 'networking/types/album-detail';

interface AlbumThumbnail {
  blobId: number;
  url: string;
}

interface AlbumCreatedByUser {
  id: number;
  companyName: string;
  email: string;
  name: string;
}

export interface Album {
  id: number;
  batchId: number | null;
  collections: any[];
  contents: AlbumContentSerialized[];
  createdAt: string;
  createdBy: number | null;
  createdByContributor: boolean;
  createdByOwner: boolean;
  guestTokenId?: number | null;
  createdByUser?: AlbumCreatedByUser;
  customThumbnailUrl: string;
  endDate: string | null;
  isPrivate: boolean;
  // The vault's hidden catch-all album. Memories created without picking an
  // album live here; it is never shown as an album itself.
  isDefault?: boolean;
  location: string | null;
  name: string;
  order: string;
  globalOrderIndex: number;
  startDate: string | null;
  thumbnail: AlbumThumbnail;
  thumbnailUrl: string;
  totalSize: number;
  updatedAt: string;
  guestInviteToken?: string;
  myAccess?: import('networking/controllers/shares-controller').MyAlbumAccess;
  shareLinkEnabled?: boolean;
}

export class Album {
  constructor(album: Album) {
    Object.assign(this, album);
  }
}
